import * as Immutable from "immutable";
import { CHARACTER_LIMIT } from "constants/messages";
import { removeTemplateVariables } from "services/strings";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class ShuffleMessageRecord
 * @augments BaseMessageRecord
 */
class ShuffleMessageRecord extends BaseMessageRecord({
  type: "shuffle",

  /**
   * @memberof ShuffleMessageRecord#
   */
  messages: Immutable.List([
    Immutable.Map({
      id: null,
      body: ""
    })
  ])
}) {}

/**
 * Validation
 */

/**
 * @param {ShuffleMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
ShuffleMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  message.messages.forEach((shuffleMessage, i) => {
    const body = shuffleMessage.get("body");
    const bodyWithoutTemplateVars = removeTemplateVariables(body);

    if (body.trim().length <= 0 || bodyWithoutTemplateVars.trim().length > CHARACTER_LIMIT) {
      invalidFields.add({ message: i });
    }
  });

  return Immutable.List(invalidFields);
};

export default ShuffleMessageRecord;
